import PropTypes from 'prop-types';

import DecorationsSVG from '../assets/decorations';

const Decorations = ({ showFooter }) => (
  <>
    {/* <div
      className="position-absolute w-100 d-flex justify-content-between align-items-start pointer-events-none decorations"
      style={{ top: 0, direction: 'rtl' }}
    >
      <DecorationsSVG.TopRightDecorationSVG />
      <DecorationsSVG.TopLeftDecorationSVG />
    </div>
    <div
      className="position-absolute w-100 d-flex justify-content-between align-items-end pointer-events-none decorations"
      style={{ bottom: 0, direction: 'rtl' }}
    >
      <DecorationsSVG.BottomRightDecorationSVG />
      <DecorationsSVG.BottomLeftDecorationSVG />
    </div> */}
    {showFooter && (
      <div className="footer" />
    )}
  </>
);

Decorations.propTypes = {
  showFooter: PropTypes.bool,
};

Decorations.defaultProps = {
  showFooter: true,
};

export default Decorations;
